import {useEffect, useState} from 'react';
import {AmbitClient, ConnectionStatus, Activity} from '@ambit-ai/ambit-client';
import {Message} from './types';
import {getMessageDetail} from '../utils/chat';
import {config} from '../environment';

const useAmbit = ({open}: {open: boolean}) => {
  const [loading, internalSetLoading] = useState<boolean>(false);
  const [messages, setMessages] = useState<Message[]>([]);
  const [botConnection] = useState(() => {
    return new AmbitClient({
      baseUrl: config.AMBIT_URL,
      secret: config.AMBIT_SECRET,
    });
  });

  useEffect(() => {
    const subscription = botConnection.connectionStatus$.subscribe(
      (connectionStatus) => {
        if (connectionStatus === ConnectionStatus.Online) {
          const activity: Activity = {
            type: 'message',
            from: botConnection.user,
            locale: 'en-GB',
            text: '',
          };
          botConnection.postActivity(activity).subscribe();
        }
      },
    );

    return () => {
      subscription.unsubscribe();
    };
  }, [botConnection, open]);

  useEffect(() => {
    const subscription = botConnection.activity$.subscribe((activity) => {
      if (activity.type === 'typing') {
        internalSetLoading(true);
      } else {
        internalSetLoading(false);
      }

      if (activity.type === 'message') {
        const newMessage = getMessageDetail(activity, botConnection.user.id);
        if (newMessage) {
          setMessages((prevMessages) => {
            const lastMessage = prevMessages[prevMessages.length - 1];
            newMessage.isNewBlock =
              !lastMessage || lastMessage.isUser !== newMessage.isUser;
            return [...prevMessages, newMessage];
          });
        }
      }
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [botConnection]);

  const sendMessage = (message: string) => {
    botConnection
      .postActivity({
        type: 'message',
        from: botConnection.user,
        locale: 'en-GB',
        text: message,
      })
      .subscribe();
  };

  return {sendMessage, loading, messages};
};

export default useAmbit;
